import { STORAGE_KEYS } from "../constants";
import { generateTransactionId } from "./calculations";

/**
 * Get stored cash-out transactions from localStorage
 */
export const getStoredTransactions = () => {
    try {
        return JSON.parse(
            localStorage.getItem(STORAGE_KEYS.CASHOUT_TRANSACTIONS) || "[]"
        );
    } catch (error) {
        console.error("Error parsing stored transactions:", error);
        return [];
    }
};

/**
 * Store cash-out transaction in localStorage
 */
export const storeTransaction = (transactionData, userInfo, company) => {
    const storedTransactions = getStoredTransactions();
    const newTransaction = {
        ...transactionData,
        timestamp: new Date().toISOString(),
        user: userInfo.name,
        company: company.company_name || company.name,
        id: generateTransactionId(),
    };
    storedTransactions.push(newTransaction);
    localStorage.setItem(
        STORAGE_KEYS.CASHOUT_TRANSACTIONS,
        JSON.stringify(storedTransactions)
    );
    return newTransaction;
};
